<template>
  <div class="flex min-h-screen flex-col">
    <CheckoutHeader>
      <span class="flex w-full justify-between pl-8">
        <PartnerLogo :partner-name />
      </span>
    </CheckoutHeader>

    <RevContainer class="py-32">
      <section class="flex flex-col items-center gap-24 md:flex-row md:gap-48">
        <div class="flex w-full flex-col gap-24 md:w-1/2">
          <header class="flex flex-col gap-8">
            <h1 class="heading-1">
              {{ i18n(translations.errorHeading) }}
            </h1>
            <p>{{ i18n(translations.errorParagraph) }}</p>
          </header>
        </div>

        <RevIllustration
          alt=""
          class="w-full md:w-1/2"
          :height="170"
          src="/img/phone-in-grass.png"
          :width="327"
        />
      </section>
    </RevContainer>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { onMounted } from 'vue'

import CheckoutHeader from '@backmarket/nuxt-layer-checkout/components/CheckoutHeader/CheckoutHeader.vue'
import PartnerLogo from '@backmarket/nuxt-layer-checkout/components/PartnerLogo/PartnerLogo.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './PartnerCheckoutError.translations'

const i18n = useI18n()
const route = useRoute()
const tracking = useTracking()

const partnerName = String(route.params.partnerName)

onMounted(() => {
  tracking.trackBlockImpression({
    event: 'block_impression',
    name: 'partner_checkout_error',
    partner: partnerName,
  })
})
</script>
